/* eslint-disable no-param-reassign */
import { PayloadAction, Slice, createSlice } from '@reduxjs/toolkit';
import * as jwt from 'jwt-decode';

interface UserInfo {
  name: string,
  email: string,
  sub: string
}

export interface Token {
  access_token: string,
  refresh_token: string
}

export interface AuthState {
  token: Token | null,
  isLoggedIn: boolean,
  user: UserInfo | null
}

// eslint-disable-next-line camelcase
const saveUserTokenInLocalStorage = ({ access_token, refresh_token }: Token) => {
  localStorage.setItem('access_token', access_token);
  localStorage.setItem('refresh_token', refresh_token);
};

const removeUserFromLocalStorage = () => {
  localStorage.clear();
};

const getUserInfoFromLocalStorage = () => {
  const localInfo = localStorage.getItem('access_token');
  if (localInfo) {
    const { name, email, sub } = jwt.jwtDecode<UserInfo>(localInfo);
    return { name, email, sub };
  }
  return { name: 'User', email: 'email@email.com', sub: 'user' };
};

const initialState: AuthState = {
  token: null,
  isLoggedIn: Boolean(localStorage.getItem('access_token')),
  user: getUserInfoFromLocalStorage(),
};
const slice: Slice<AuthState> = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (
      state,
      { payload }: PayloadAction<Token>,
    ) => {
      saveUserTokenInLocalStorage(payload);
      state.token = payload;
      state.isLoggedIn = true;
      state.user = jwt.jwtDecode(payload.access_token);
    },
    logout: () => {
      removeUserFromLocalStorage();
      return {
        token: null,
        isLoggedIn: false,
        user: null,
      };
    },
  },
});

export const { setCredentials, logout } = slice.actions;

export default slice.reducer;
